import * as React from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import {Button} from "@mui/material";


export default function SplitButton({children, tariffId, buttonList, onClick}) {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleMenuItemClick = (event, index) => {
        onClick(index);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    return (
        <>
            <div ref={anchorRef} onClick={handleToggle}>{children}</div>
            <Popper sx={{zIndex: 1}} open={open} anchorEl={anchorRef.current} transition disablePortal>
                {({TransitionProps, placement}) => (
                    <Grow {...TransitionProps} style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem>
                                    {buttonList.map((button, index) => (
                                        <MenuItem key={index} onClick={(event) => handleMenuItemClick(event, index)}>
                                            <Button id={`chooseTariff-${tariffId}-${button.months}`}>
                                                {button.title}
                                            </Button>
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    );
}
